import { nanoid } from 'nanoid'

import { IUserData } from 'meta/auth'
import { CookieClient, CookieName } from 'utils/cookie'
import { sha256 } from 'utils/hash'
import { HttpRequest } from 'utils/http'

interface IAnalyticsBackendData {
  route: string
  fromOrganizer: boolean
  s2sToken: string
}

interface IMetaPixelUserData {
  em?: string
  ph?: string
  client_user_agent: string
  fbp: string
  fbc: string
}

export enum AnalyticsEventType {
  Purchase = 'Purchase',
  ViewContent = 'ViewContent',
  InitiateCheckout = 'InitiateCheckout',
  RemoveFromCart = 'RemoveFromCart',
  AddToCart = 'AddToCart',
}

export enum AnalyticsContentType {
  ticket = 'ticket',
  good = 'good',
}

const getUserDataForMetaPixelEvent = async (userData?: IUserData): Promise<IMetaPixelUserData> => {
  if (!userData) {
    return {
      client_user_agent: navigator.userAgent,
      fbp: CookieClient.get(CookieName.META_FBP),
      fbc: CookieClient.get(CookieName.META_FBC),
    }
  }

  const emailHash = await sha256(userData.email)
  const phoneHash = await sha256(`${userData.phonePrefix}${userData.phone}`)

  return {
    em: emailHash,
    ph: phoneHash,
    client_user_agent: navigator.userAgent,
    fbp: CookieClient.get(CookieName.META_FBP),
    fbc: CookieClient.get(CookieName.META_FBC),
  }
}

export const trackFbPixelEvent = async (
  name: AnalyticsEventType,
  eventData: object = {},
  backendData: IAnalyticsBackendData,
  userData?: IUserData
) => {
  const { route, s2sToken } = backendData

  //@ts-expect-error fbq might not be defined
  if (window && window.fbq) {
    // generate uuid as eventId
    const eventId = nanoid()

    //@ts-expect-error fbq might not be defined
    window.fbq('track', name, { ...eventData, "ticket_platform": "TicketSms" }, {
      eventId: eventId,
    })

    await HttpRequest.post(
      route,
      {
        'facebook': {
          'facebookEvent': {
            'custom_data': eventData,
            'event_name': name,
            'event_id': eventId,
            'event_source_url': window.location.href,
            'user_data': await getUserDataForMetaPixelEvent(userData),
          },
        },
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Tsms-S2S-Token': s2sToken,
          'Ticket-Otp-Token': s2sToken,
        },
      }
    )
  }
}
